import { Line, LineSvgProps } from '@nivo/line'
import { useEffect, useState } from 'react'

const X_AXIS_VISIBLE_MAX = 14
const CHART_STYLE: Partial<LineSvgProps> = {
  curve: 'linear',
  margin: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  role: 'presentation',
  colors: ['rgba(198, 211, 230, 1)'],
  animate: true,
  lineWidth: 3,
  pointSize: 0,
}

interface Props {
  data: any[]
  marker?: boolean
  dataKey: string
  indexBy: string
  options?: Partial<LineSvgProps>
  width: number
  height: number
}
const getChartGraphData = (data, dataKey, indexBy) => {
  // x축 y축 Axis가 없는 그래프에서 Y축 값들을 높이만큼 비례하게 보여주기위해 최소값을 y축 값들에서 빼줌
  const min = Math.min(...(data?.map((item) => Math.floor(item[dataKey])) || []))
  if (data.length < X_AXIS_VISIBLE_MAX) {
    const gap = X_AXIS_VISIBLE_MAX - data.length
    const blanks = Array(gap)
      .fill(0)
      .map((_, i) => ({
        x: i,
        y: null,
      }))
    const validDatas = data.map((item, i) => {
      return {
        x: gap + i,
        y: Number(item[dataKey]?.toFixed(0)) - min,
      }
    })
    return [
      {
        id: 'line',
        data: [...blanks, ...validDatas],
      },
    ]
  } else {
    return [
      {
        id: 'line',
        data: Array(X_AXIS_VISIBLE_MAX)
          .fill(0)
          .map((_, i) => {
            console.log(Number(data[i][dataKey]?.toFixed(0)) - min, 'Number(data[i][dataKey]?.toFixed(0)) - min')
            return {
              x: i,
              y: data[i] ? Number(data[i][dataKey]?.toFixed(0)) - min : 0,
            }
          }),
      },
    ]
  }
}
const SimpleLineChart = ({ data, dataKey, indexBy, options = {}, width, height }: Props) => {
  const [graphData, setGraphData] = useState([])
  console.log('graphData', graphData)
  console.log('width, height', width, height)
  // 렌더링 시 데이터 변할 때마다 다시 그리도록 useEffect 명시적으로 추가
  useEffect(() => {
    if (Array.isArray(data)) {
      setGraphData(getChartGraphData(data, dataKey, indexBy))
    }
  }, [data, dataKey, indexBy])
  if (!Array.isArray(graphData[0]?.data)) {
    return null
  }
  if (graphData[0].data.every((item) => isNaN(item.y))) {
    console.log('SimpleLineChart ERROR: invalid props => dataKey, indexBy', dataKey, indexBy)
    return null
  }
  return (
    <Line
      {...CHART_STYLE}
      data={graphData}
      height={height}
      width={width}
      enableGridX={false}
      enableGridY={false}
      axisLeft={null}
      axisBottom={null}
      {...options}
    />
  )
}

export default SimpleLineChart
